<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Categories",
};
</script>

<style scoped></style>
